export enum  EnumTipoDeVenda{
  Unidade = 'Unidade',
  Peso =  'Peso'
}
